import * as actions from '../../../store/slices'
import { useDispatch, useSelector } from 'react-redux'
import { supportProgramTypes } from '../../../constants/support-programs'
import constants from '../../../constants'
const useVerifyMedicalCode = () => {
  const dispatch = useDispatch()
  const supportProgram = supportProgramTypes[constants.CARE_PROGRAM_TYPE.VIEMAX]
  const {
    verifyMedicationCode: {
      loading: isLoading,
      error: verifyError,
      data,
      success,
    },
  } = useSelector((state) => state.carePlan)

  const handleVerifyMedicationCode = (code = '') => {
    dispatch(
      actions.verifyMedicationCodeRequest({
        uniqueMedicationCode: code.toString()?.toUpperCase(),
        medicationName: supportProgram.partnerName,
      }),
    )
  }

  return { handleVerifyMedicationCode, isLoading, verifyError, data, success }
}

export default useVerifyMedicalCode
